<template>
  <v-layout>
    <v-flex>
      <v-row align="center" no-gutters>
        <v-col class="text-left ml-n6" cols="12" md="6">
          <v-breadcrumbs :items="subNavs"></v-breadcrumbs>
        </v-col>
        <v-col class="text-right"  cols="12" md="6">
          <ActionButtons
            @doClose="doClose"
            @doPrint="doPrint"
            :actionBtnSettings="actionBtnSettings"
          >
          </ActionButtons>
        </v-col>
      </v-row>

      <v-card class="pa-6 mt-3">
        <v-card-title>
          Dispatch Order
          <v-spacer></v-spacer>
          <DeliveryStatus :status="delivery.status" :statuses="statuses"></DeliveryStatus>
        </v-card-title>
        <v-card-subtitle>
          #{{delivery.delivery_no}}
          <v-spacer></v-spacer>
        </v-card-subtitle>
        <v-card-text class="text--primary mt-6">

          <v-row no-gutters>
            <v-col cols="12" sm="12" md="6">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-account-outline
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{delivery.deliver_to_name}}</v-list-item-title>
                    <v-list-item-subtitle>Dispatch To</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ delivery.delivery_date | moment("MMM D, YYYY") }}</v-list-item-title>
                    <v-list-item-subtitle>Dispatch Date</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-map-marker-outline
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{delivery.deliver_to_address}}</v-list-item-title>
                    <v-list-item-subtitle>Address</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-receipt-text-outline
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{delivery.ref_no ? delivery.ref_no : '-'}}</v-list-item-title>
                    <v-list-item-subtitle>Reference No.</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-phone-classic
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{delivery.deliver_to_contact_no}}</v-list-item-title>
                    <v-list-item-subtitle>Contact No.</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-note-outline
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{delivery.remarks ? delivery.remarks : '-'}}</v-list-item-title>
                    <v-list-item-subtitle>Remarks</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-truck-delivery-outline
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{delivery.plate_no}}</v-list-item-title>
                    <v-list-item-subtitle>Plate No.</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>

          <v-data-table
            class="mt-10"
            :headers="headers"
            :items="items"
            :loading="loading"
            :items-per-page="1000"
            hide-default-footer
            loading-text="Loading Items..."
            no-data-text="No Items"
            ref="table">

            <template v-slot:[`item.qty`]="{ item }">
              {{ formatNumber(item.qty) }}
            </template>
            <template v-slot:[`item.cbm`]="{ item }">
              {{ formatNumber(item.cbm) }}
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              {{ formatNumberAmount($numeral, item.amount) }}
            </template>


          </v-data-table>
          <v-divider></v-divider>
        </v-card-text>

      </v-card>

      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>

      <Loader :loading="loading"></Loader>
    </v-flex>
  </v-layout>
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import Loader from '@/components/Loader.vue'
  import { mapGetters } from "vuex";
  import ActionButtons from '@/components/ActionButtons.vue'
  import DeliveryStatus from '@/components/DeliveryStatus.vue'

  export default {
    name: 'DOViewPage',
    data: () => ({
      id: null,
      adminNamespace: 'admin',
      loading: false,
      isLoading: false,
      deletedItems: [],
      perPage: 2000,
      print: false,
      actionBtnSettings: {
        edit: 0,
        save: 0,
        refresh: 0,
        close: 1,
        print: 1,
        send: 0,
        save_and_print: 0,
        save_disabled: false,
        close_disabled: false,
        print_disabled: false,
        save_and_print_disabled: false
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      delivery: {
        id: '',
        delivery_no: '',
        ref_no: '',
        deliver_to_name: '',
        deliver_to_contact_no: '',
        deliver_to_address: '',
        delivery_date: '',
        remarks: '',
        sub_total: 0,
        discounts: 0,
        other_charges: 0,
        net_amount: 0
      },
      statuses: [],
      subNavs: [
        {
          text: 'Dispatch Orders',
          disabled: false,
          exact: true,
          to: {
            name: 'delivery-orders'
          },
        },
        {
          text: 'View Dispatch Order',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      items: [],
      headers: [
        {
          text: 'Shipping Mark',
          align: 'start',
          value: 'shipping_mark',
          sortable: false,
          width: 200
        },
        {
          text: 'Item',
          align: 'start',
          value: 'description',
          sortable: false
        },
        {
          text: 'Qty',
          align: 'center',
          value: 'qty',
          sortable: false,
          width: 180
        }
      ]
    }),
    watch: {
    },
    computed: {
      ...mapGetters(['formatNumberAmount', 'formatNumber', 'formatNumberAmountNoComma', 'getCurrentUser']),
    },
    methods: {
      doClose (){
        this.$router.push({ name: 'delivery-orders' })
      },
      doPrint (){
        this.print = true
        this.getDelivery()
      },
      getDelivery () {
        if(this.print){
          window.open('/api/'+this.adminNamespace+'/deliveries/'+this.id+'?print=true', '_newtab');
          return false
        }
        let self = this
        this.loading = true
        this.$http.plain.get(this.adminNamespace+'/deliveries/'+this.id)
          .then(response => {
            this.delivery = response.data
            this.items = this.delivery.items
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
      },
      getDefaultData () {
        let self = this
        this.$http.plain.get('/default-data?delivery_statuses=true')
          .then(response => {
            this.statuses = response.data.delivery_statuses
          })
          .catch(error => {
            console.log(error);
          })
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      }
    },
    mounted() {
      if(this.$route.params.id != 'add'){
        this.id = this.$route.params.id
      }
      this.getDefaultData()
      this.getDelivery()
    },
    components: {
      SnackBar,
      Loader,
      ActionButtons,
      DeliveryStatus
    }
  }
</script>
